'use strict';
/* SEDRAH shop layer — Shopify port. Catalog injected by the layout (window.SEDRAH_CATALOG). */
var SEDRAH_META = {
  'restore-mask': { name_ar: 'ماسك سدرة المُرمِّم', subtitle: 'For All Hair Types', badge: 'Best Seller', prefix: 'mask' },
  'essence-oil':  { name_ar: 'زيت سدرة الأساسي',  subtitle: 'For All Hair Types', badge: 'New',        prefix: 'oil' },
  'sedar-ritual': { name_ar: 'طقم السدر — ماسك + زيت', subtitle: 'Mask 100ML + Oil 100ML', badge: 'Bundle', prefix: 'bundle' }
};
(function () {
  const CART_KEY = 'sedrah_cart';
  const AR = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const arNum = (n) => String(n).replace(/\d/g, (d) => AR[d]);
  const fmtSar = (n) => arNum(n) + ' ر.س';
  // Customers type numbers in Arabic-Indic digits; fold them before validating
  // or sending, so client and server agree on what a valid phone looks like.
  const foldDigits = (s) => String(s)
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06F0));

  let catalog = null;          // { byCode: {code → {code,size,price,product}}, products: [...] }
  let appliedDiscount = null;  // { code, percent, amount }

  /* ── Utilities ── */
  function el(tag, attrs, children) {
    const node = document.createElement(tag);
    if (attrs) {
      for (const [k, v] of Object.entries(attrs)) {
        if (k === 'text') node.textContent = v;
        else if (k === 'html') node.innerHTML = v; // static markup only, never user data
        else if (k.startsWith('on')) node.addEventListener(k.slice(2), v);
        else node.setAttribute(k, v);
      }
    }
    (children || []).forEach((c) => node.appendChild(c));
    return node;
  }

  async function api(path, body) {
    const res = await fetch(path, body === undefined ? undefined : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    let data = {};
    try { data = await res.json(); } catch { /* empty/204 */ }
    return { ok: res.ok, status: res.status, data };
  }

  /* ── Analytics: Meta Pixel + TikTok Pixel ──
     Pixel base code is loaded by snippets/sedrah-pixels.liquid when IDs are set in
     Theme settings → Tracking. This routes the storefront funnel events the theme
     alone can see (modal views, local-cart adds, checkout taps). Purchase fires
     from the checkout via the custom pixel (Settings → Customer events). */
  function rawProduct(slug) {
    if (catalog) { const p = catalog.products.find((x) => x.slug === slug); if (p) return p; }
    const raw = (window.SEDRAH_CATALOG && window.SEDRAH_CATALOG.products) || [];
    return raw.find((x) => x.slug === slug) || null;
  }
  function track(event, data) {
    try {
      if (window.console && console.debug) console.debug('[sedrah-track]', event, data || null);
    } catch { /* noop */ }
    try {
      const fb = typeof window.fbq === 'function' ? window.fbq : null;
      const tt = window.ttq && typeof window.ttq.track === 'function' ? window.ttq : null;
      if (!fb && !tt) return;
      const d = data || {};
      const CUR = 'SAR';
      if (event === 'view_item') {
        const p = rawProduct(d.product); if (!p) return;
        const v = p.variants && p.variants[0]; const price = v ? Number(v.price) : 0;
        const id = String(p.productId || p.slug);
        if (fb) fb('track', 'ViewContent', { content_ids: [id], content_name: p.name_en, content_type: 'product', value: price, currency: CUR });
        if (tt) tt.track('ViewContent', { contents: [{ content_id: id, content_name: p.name_en, price, quantity: 1 }], content_type: 'product', value: price, currency: CUR });
      } else if (event === 'add_to_cart') {
        const v = catalog && catalog.byCode[d.code]; if (!v) return;
        const id = String(v.product.productId || v.product.slug); const qty = d.qty || 1; const value = Number(v.price) * qty;
        if (fb) fb('track', 'AddToCart', { content_ids: [id], content_name: v.product.name_en, content_type: 'product', value, currency: CUR, num_items: qty });
        if (tt) tt.track('AddToCart', { contents: [{ content_id: id, content_name: v.product.name_en, price: Number(v.price), quantity: qty }], content_type: 'product', value, currency: CUR });
      } else if (event === 'begin_checkout') {
        const ids = [], contents = []; let n = 0;
        getCart().forEach((l) => {
          const v = catalog && catalog.byCode[l.code]; if (!v) return;
          const id = String(v.product.productId || v.product.slug);
          ids.push(id); n += l.qty;
          contents.push({ content_id: id, content_name: v.product.name_en, price: Number(v.price), quantity: l.qty });
        });
        const value = Number(d.subtotal || 0);
        if (fb) fb('track', 'InitiateCheckout', { content_ids: ids, content_type: 'product', value, currency: CUR, num_items: n });
        if (tt) tt.track('InitiateCheckout', { contents, content_type: 'product', value, currency: CUR });
      }
    } catch { /* analytics must never break the shop */ }
  }

  /* ── Toast ── */
  let toastTimer = null;
  function toast(msg) {
    let t = document.querySelector('.shop-toast');
    if (!t) { t = el('div', { class: 'shop-toast' }); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2600);
  }

  /* ── Catalog ── */
  async function loadCatalog() {
    if (catalog) return catalog;
    const raw = (window.SEDRAH_CATALOG && window.SEDRAH_CATALOG.products) || [];
    if (!raw.length) throw new Error('catalog');
    const falls = window.SEDRAH_ASSET_FALLBACKS || {};
    const byCode = {};
    const products = raw.map((sp) => {
      const meta = SEDRAH_META[sp.slug] || { prefix: sp.slug };
      return {
        slug: sp.slug, productId: sp.productId || null, name_en: sp.name_en,
        name_ar: meta.name_ar || sp.name_en, subtitle: meta.subtitle || '', badge: meta.badge || '',
        image: sp.image || falls[sp.slug] || null, description: sp.description,
        available: sp.available !== false,
        variants: sp.variants.map((v) => { const n = parseInt(v.size, 10); return { code: meta.prefix + '-' + (isNaN(n) ? 'std' : n), size: v.size, price: v.price, shopifyId: v.shopifyId, available: v.available !== false }; }),
      };
    });
    for (const p of products) {
      for (const v of p.variants) byCode[v.code] = { ...v, product: p };
    }
    catalog = { byCode, products };
    // Drop cart lines for products that no longer exist. They render as
    // nothing (so there'd be no remove button) but would still be submitted,
    // which would make every checkout fail with no way out.
    const lines = getCart();
    const kept = lines.filter((l) => byCode[l.code]);
    if (kept.length !== lines.length) {
      setCart(kept);
      toast('أزلنا من سلتك منتجاً لم يعد متوفراً');
    }
    return catalog;
  }

  /* ── Cart state ── */
  // In-memory mirror so the cart still works when storage is blocked
  // (Instagram/Snapchat in-app browsers, some private modes).
  let memCart = null;
  function getCart() {
    let c = null;
    try { c = JSON.parse(localStorage.getItem(CART_KEY) || 'null'); } catch { /* blocked or corrupt */ }
    if (!Array.isArray(c)) c = Array.isArray(memCart) ? memCart : [];
    return c.filter((l) => l && typeof l.code === 'string' && Number.isInteger(l.qty) && l.qty > 0);
  }
  function setCart(lines) {
    memCart = lines;
    try { localStorage.setItem(CART_KEY, JSON.stringify(lines)); } catch { /* keep in memory */ }
    updateBadge();
  }
  const HANDOFF_KEY = 'sedrah_handoff_v1';
  function markHandoff() { try { localStorage.setItem(HANDOFF_KEY, String(Date.now())); } catch { /* noop */ } }
  function clearHandoff() { try { localStorage.removeItem(HANDOFF_KEY); } catch { /* noop */ } }
  // After a checkout hand-off, Shopify empties its cart once the order is placed.
  // Mirror that locally so the customer doesn't re-order the same basket.
  async function reconcileAfterCheckout() {
    let at = 0;
    try { at = Number(localStorage.getItem(HANDOFF_KEY) || 0); } catch { return; }
    if (!at) return;
    if (Date.now() - at > 48 * 3600 * 1000) { clearHandoff(); return; } // too old to trust an empty Shopify cart
    if (!getCart().length) { clearHandoff(); return; }
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!r.ok) return;
      const c = await r.json();
      if (c && c.item_count === 0) { setCart([]); clearHandoff(); if (sheets.cart && sheets.cart.sheet.style.display !== 'none') renderCart(); }
    } catch { /* retry next load */ }
  }
  function cartCount() { return getCart().reduce((s, l) => s + l.qty, 0); }
  function cartSubtotal() {
    if (!catalog) return 0;
    return getCart().reduce((s, l) => {
      const v = catalog.byCode[l.code];
      if (!v) return s;
      const unit = v.price;
      return s + unit * l.qty;
    }, 0);
  }

  let lastAdd = { code: null, at: 0 };
  function addToCart(code, qty, mode) {
    const now = Date.now();
    if (lastAdd.code === code && now - lastAdd.at < 600) return; // double-tap
    lastAdd = { code, at: now };
    const v = catalog && catalog.byCode[code];
    if (v && v.available === false) { toast('نفدت الكمية حالياً — نعيد توفيرها قريباً'); return; }
    const lines = getCart();
    const found = lines.find((l) => l.code === code && l.mode === mode);
    if (found) found.qty = Math.min(found.qty + qty, 10);
    else lines.push({ code, qty: Math.min(qty, 10), mode });
    setCart(lines);
    track('add_to_cart', { code, qty, mode });
    toast('أُضيفت إلى السلة ✓');
    openCart();
  }

  /* ── Badge ── */
  function updateBadge() {
    const btn = document.querySelector('header .hdr-icons button[aria-label="Cart"]');
    if (!btn) return;
    btn.classList.add('cart-btn-wrap');
    let badge = btn.querySelector('.cart-badge');
    const n = cartCount();
    if (!badge) { badge = el('span', { class: 'cart-badge', 'aria-hidden': 'true' }); btn.appendChild(badge); }
    badge.textContent = arNum(n);
    badge.style.display = n ? 'flex' : 'none';
  }

  /* ── Sheets (generic open/close) ── */
  const sheets = {};
  function buildSheet(id, title) {
    const overlay = el('div', { class: 'shop-overlay', style: 'display:none' });
    const sheet = el('div', { class: 'shop-sheet', dir: 'rtl', role: 'dialog', 'aria-modal': 'true', 'aria-label': title, style: 'display:none' });
    const closeBtn = el('button', { class: 'shop-sheet-close', 'aria-label': 'إغلاق', text: '✕', onclick: () => closeSheet(id) });
    const hdr = el('div', { class: 'shop-sheet-hdr' }, [
      el('div', { class: 'shop-sheet-title', text: title }),
      closeBtn,
    ]);
    const body = el('div', { class: 'shop-sheet-body' });
    sheet.appendChild(hdr);
    sheet.appendChild(body);
    overlay.addEventListener('click', () => closeSheet(id));
    document.body.appendChild(overlay);
    document.body.appendChild(sheet);
    sheets[id] = { overlay, sheet, body, closeBtn };
    return sheets[id];
  }
  function openSheet(id) {
    const s = sheets[id];
    s.overlay.style.display = 'block';
    s.sheet.style.display = 'flex';
    // rAF for a clean transition, plus a timeout fallback (rAF is throttled
    // in hidden/background tabs and the sheet must still open).
    const show = () => { s.overlay.classList.add('open'); s.sheet.classList.add('open'); };
    requestAnimationFrame(show);
    setTimeout(show, 60);
    document.body.style.overflow = 'hidden';
    setTimeout(() => s.closeBtn.focus(), 300);
  }
  function closeSheet(id) {
    const s = sheets[id];
    s.overlay.classList.remove('open');
    s.sheet.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => {
      s.overlay.style.display = 'none';
      s.sheet.style.display = 'none';
    }, 300);
  }
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    for (const id of Object.keys(sheets)) {
      if (sheets[id].sheet.classList.contains('open')) { closeSheet(id); return; }
    }
  });

  /* ── Cart sheet ── */
  function renderCart() {
    const s = sheets.cart || buildSheet('cart', 'سلة التسوق');
    const body = s.body;
    body.textContent = '';
    const lines = getCart();

    if (!lines.length) {
      body.appendChild(el('div', { class: 'cart-empty', text: 'سلتك فارغة 🛒 تصفحي منتجاتنا وأضيفي ما يعجبك' }));
      return;
    }
    for (const line of lines) {
      const v = catalog && catalog.byCode[line.code];
      if (!v) continue;
      const unit = v.price;
      const qtyBox = el('span', { class: 'cart-qty' }, [
        el('button', { 'aria-label': 'إنقاص الكمية', text: '−', onclick: () => changeLine(line, -1) }),
        el('span', { text: arNum(line.qty) }),
        el('button', { 'aria-label': 'زيادة الكمية', text: '+', onclick: () => changeLine(line, +1) }),
      ]);
      body.appendChild(el('div', { class: 'cart-line' }, [
        el('img', { class: 'cart-line-img', src: v.product.image, alt: v.product.name_en }),
        el('div', { class: 'cart-line-info' }, [
          el('div', { class: 'cart-line-name', text: v.product.name_en }),
          el('div', { class: 'cart-line-meta', text: v.size }),
          el('div', {}, [
            qtyBox,
            el('button', { class: 'cart-remove', text: 'إزالة', onclick: () => removeLine(line) }),
          ]),
        ]),
        el('div', { class: 'cart-line-price', text: fmtSar(unit * line.qty) }),
      ]));
    }

    const subtotal = cartSubtotal();
    const summary = el('div', { class: 'cart-summary' }, [
      el('div', { class: 'cart-summary-row' }, [
        el('span', { text: 'المجموع الفرعي' }), el('span', { text: fmtSar(subtotal) }),
      ]),
      el('div', { class: 'cart-summary-row' }, [
        el('span', { text: 'الشحن' }), el('span', { class: 'pos', text: 'مجاني' }),
      ]),
      el('div', { class: 'cart-vat-note', text: 'الأسعار شاملة ضريبة القيمة المضافة' }),
    ]);
    body.appendChild(summary);
    body.appendChild(el('button', { class: 'shop-cta', text: 'إتمام الطلب — الدفع عند الاستلام', onclick: shopifyCheckout }));
  }
  function changeLine(line, delta) {
    const lines = getCart();
    const t = lines.find((l) => l.code === line.code && l.mode === line.mode);
    if (!t) return;
    t.qty = Math.max(1, Math.min(10, t.qty + delta));
    setCart(lines);
    renderCart();
  }
  function removeLine(line) {
    setCart(getCart().filter((l) => !(l.code === line.code && l.mode === line.mode)));
    renderCart();
  }
  async function openCart() {
    try { await loadCatalog(); } catch { toast('تعذر تحميل المنتجات — تأكدي من اتصال الخادم'); return; }
    renderCart();
    openSheet('cart');
  }

  /* ── Shopify checkout hand-off ── */
  let checkoutInFlight = false;
  function setCheckoutBusy(busy) {
    checkoutInFlight = busy;
    if (!sheets.cart) return;
    sheets.cart.body.querySelectorAll('.shop-cta').forEach((b) => {
      b.disabled = busy;
      if (busy) { b.dataset.label = b.textContent; b.textContent = 'جارٍ التحويل إلى الدفع…'; }
      else if (b.dataset.label) b.textContent = b.dataset.label;
    });
  }
  async function shopifyCheckout() {
    if (checkoutInFlight) return;          // synchronous guard: rapid taps can't pass this
    setCheckoutBusy(true);
    let navigating = false;
    try {
      const lines = getCart();
      if (!lines.length) { toast('سلتك فارغة'); return; }
      try { await loadCatalog(); } catch { toast('تعذر تحميل المنتجات'); return; }
      // Drop anything that sold out since it was added, and let the customer see the change.
      const kept = lines.filter((l) => catalog.byCode[l.code] && catalog.byCode[l.code].available !== false);
      if (kept.length !== lines.length) {
        setCart(kept); renderCart();
        toast(kept.length ? 'نفدت كمية أحد المنتجات وأزلناه من سلتك' : 'نفدت كمية المنتج — أزلناه من سلتك');
        return;
      }
      track('begin_checkout', { subtotal: cartSubtotal() });
      const items = lines.map((l) => ({ id: catalog.byCode[l.code].shopifyId, quantity: l.qty }));
      const c = await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
      if (!c.ok) throw new Error('clear');
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (r.status === 422 || r.status === 404) {
        let desc = '';
        try { const j = await r.json(); desc = (j && (j.description || j.message)) || ''; } catch { /* noop */ }
        // Sold out, or a variant that no longer exists (page loaded before a catalog change).
        toast(desc ? ('تعذّر إتمام الطلب: ' + desc) : 'نفدت كمية أحد المنتجات — حدّثي الصفحة وحاولي مرة أخرى');
        return;
      }
      if (!r.ok) throw new Error('add');
      markHandoff();
      navigating = true;
      window.location.href = '/checkout';
    } catch {
      toast('تعذر الاتصال بالخادم — حاولي مرة أخرى');
    } finally {
      if (!navigating) setCheckoutBusy(false);
    }
  }

  async function storefrontFormPost(fields) {
    const fd = new URLSearchParams();
    fd.set('utf8', '\u2713');
    for (const [k, v] of Object.entries(fields)) fd.set(k, v);
    const res = await fetch('/contact', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: fd.toString() });
    return res.ok;
  }
  const looksLikeEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);

  /* ── Checkout sheet ── */
  const CITIES = ['الرياض', 'جدة', 'مكة المكرمة', 'المدينة المنورة', 'الدمام', 'الخبر', 'الظهران', 'الأحساء', 'القطيف', 'الجبيل', 'الطائف', 'تبوك', 'بريدة', 'عنيزة', 'حائل', 'أبها', 'خميس مشيط', 'جازان', 'نجران', 'الباحة', 'ينبع', 'الخرج', 'عرعر', 'سكاكا'];

  function field(id, label, opts) {
    const o = opts || {};
    const input = o.textarea
      ? el('textarea', { class: 'co-textarea', id })
      : el('input', { class: 'co-input', id, type: o.type || 'text' });
    if (o.placeholder) input.setAttribute('placeholder', o.placeholder);
    if (o.dir) input.setAttribute('dir', o.dir);
    if (o.inputmode) input.setAttribute('inputmode', o.inputmode);
    if (o.list) input.setAttribute('list', o.list);
    if (o.autocomplete) input.setAttribute('autocomplete', o.autocomplete);
    const wrap = el('div', { class: 'co-field' }, [
      el('label', { class: 'co-label', for: id, html: label }),
      input,
      el('div', { class: 'co-error', id: id + '-err' }),
    ]);
    return wrap;
  }
  const fieldVal = (id) => (document.getElementById(id) ? document.getElementById(id).value.trim() : '');
  function fieldErr(id, msg) {
    const input = document.getElementById(id);
    const err = document.getElementById(id + '-err');
    if (input) input.classList.toggle('err', !!msg);
    if (err) { err.textContent = msg || ''; err.classList.toggle('show', !!msg); }
  }

  function openCheckout() {
    if (!getCart().length) { toast('سلتك فارغة'); return; }
    const s = sheets.checkout || buildSheet('checkout', 'إتمام الطلب');
    const body = s.body;
    body.textContent = '';
    appliedDiscount = null;
    track('begin_checkout', { subtotal: cartSubtotal() });

    const datalist = el('datalist', { id: 'cityList' }, CITIES.map((c) => el('option', { value: c })));
    body.appendChild(datalist);

    body.appendChild(field('co-name', 'الاسم الكامل', { autocomplete: 'name' }));
    body.appendChild(field('co-phone', 'رقم الجوال <small>(مثال: 05XXXXXXXX)</small>', { type: 'tel', dir: 'ltr', inputmode: 'tel', placeholder: '05XXXXXXXX', autocomplete: 'tel' }));
    const row = el('div', { class: 'co-row2' }, [
      field('co-city', 'المدينة', { list: 'cityList' }),
      field('co-district', 'الحي <small>(اختياري)</small>'),
    ]);
    body.appendChild(row);
    body.appendChild(field('co-address', 'العنوان التفصيلي', { placeholder: 'اسم الشارع، رقم المبنى / الشقة، أقرب معلم' }));
    body.appendChild(field('co-notes', 'ملاحظات <small>(اختياري)</small>', { textarea: true }));

    // Discount
    const discMsg = el('div', { class: 'co-discount-msg', id: 'co-disc-msg' });
    body.appendChild(el('div', { class: 'co-field' }, [
      el('label', { class: 'co-label', for: 'co-code', text: 'كود الخصم' }),
      el('div', { class: 'co-discount-row' }, [
        el('input', { class: 'co-input', id: 'co-code', dir: 'ltr', placeholder: 'WELCOME15' }),
        el('button', { class: 'co-apply', text: 'تطبيق', onclick: applyDiscount }),
      ]),
      discMsg,
    ]));

    // Payment (COD only)
    body.appendChild(el('div', { class: 'co-payment', html: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/></svg><span>الدفع عند الاستلام (كاش أو شبكة)</span>' }));
    body.appendChild(el('div', { class: 'co-payment-note', text: 'توصيل مجاني لجميع مدن المملكة · الأسعار شاملة الضريبة' }));

    // Summary
    body.appendChild(el('div', { class: 'cart-summary', id: 'co-summary' }));
    renderCheckoutSummary();

    const submitBtn = el('button', { class: 'shop-cta', text: 'تأكيد الطلب', onclick: submitOrder });
    body.appendChild(submitBtn);
    body.appendChild(el('button', { class: 'shop-cta-sub', text: '‹ الرجوع إلى السلة', onclick: () => { closeSheet('checkout'); openCart(); } }));

    closeSheet('cart');
    openSheet('checkout');
  }

  function renderCheckoutSummary() {
    const box = document.getElementById('co-summary');
    if (!box) return;
    box.textContent = '';
    const subtotal = cartSubtotal();
    const discount = appliedDiscount ? appliedDiscount.amount : 0;
    box.appendChild(el('div', { class: 'cart-summary-row' }, [
      el('span', { text: 'المجموع الفرعي' }), el('span', { text: fmtSar(subtotal) }),
    ]));
    if (discount) {
      box.appendChild(el('div', { class: 'cart-summary-row' }, [
        el('span', { text: `الخصم (${appliedDiscount.code})` }),
        el('span', { class: 'pos', text: '−' + fmtSar(discount) }),
      ]));
    }
    box.appendChild(el('div', { class: 'cart-summary-row' }, [
      el('span', { text: 'الشحن' }), el('span', { class: 'pos', text: 'مجاني' }),
    ]));
    box.appendChild(el('div', { class: 'cart-summary-row total' }, [
      el('span', { text: 'الإجمالي' }), el('span', { text: fmtSar(subtotal - discount) }),
    ]));
  }

  async function applyDiscount() {
    const code = fieldVal('co-code');
    const msg = document.getElementById('co-disc-msg');
    if (!code) { appliedDiscount = null; msg.textContent = ''; renderCheckoutSummary(); return; }
    let data;
    try {
      ({ data } = await api('/api/discount/check', {
        code, subtotal: cartSubtotal(), phone: foldDigits(fieldVal('co-phone')) || undefined,
      }));
    } catch {
      msg.classList.remove('ok');
      msg.classList.add('bad');
      msg.textContent = 'تعذر التحقق من الكود — تأكدي من الاتصال';
      return;
    }
    msg.classList.remove('ok', 'bad');
    if (data.valid) {
      appliedDiscount = { code: data.code, percent: data.percent, amount: data.amount };
      msg.classList.add('ok');
      msg.textContent = `تم تطبيق خصم ${arNum(data.percent)}٪ ✓`;
    } else {
      appliedDiscount = null;
      msg.classList.add('bad');
      msg.textContent = data.reason === 'first_order_only'
        ? 'هذا الكود خاص بالطلب الأول فقط'
        : 'كود الخصم غير صالح';
    }
    renderCheckoutSummary();
  }

  async function submitOrder() {
    ['co-name', 'co-phone', 'co-city', 'co-address'].forEach((id) => fieldErr(id, ''));
    let bad = false;
    if (!fieldVal('co-name')) { fieldErr('co-name', 'الرجاء كتابة الاسم'); bad = true; }
    if (!/^(?:00966|\+?966|0)?\s*5[\d\s-]{8,}$/.test(foldDigits(fieldVal('co-phone')))) { fieldErr('co-phone', 'رقم الجوال غير صحيح — مثال: 05XXXXXXXX'); bad = true; }
    if (!fieldVal('co-city')) { fieldErr('co-city', 'الرجاء كتابة المدينة'); bad = true; }
    if (!fieldVal('co-address')) { fieldErr('co-address', 'الرجاء كتابة العنوان'); bad = true; }
    if (bad) return;

    const btns = sheets.checkout.body.querySelectorAll('.shop-cta');
    btns.forEach((b) => { b.disabled = true; });
    const payload = {
      customer: {
        name: fieldVal('co-name'),
        phone: foldDigits(fieldVal('co-phone')),
        city: fieldVal('co-city'),
        district: fieldVal('co-district') || undefined,
        address: fieldVal('co-address'),
        notes: fieldVal('co-notes') || undefined,
      },
      items: getCart().map((l) => ({ code: l.code, qty: l.qty, mode: l.mode === 'sub' ? 'sub' : 'once' })),
      discountCode: appliedDiscount ? appliedDiscount.code : undefined,
    };
    let res;
    try {
      res = await api('/api/orders', payload);
    } catch {
      btns.forEach((b) => { b.disabled = false; });
      toast('تعذر الاتصال بالخادم — حاولي مرة أخرى');
      return;
    }
    if (!res.ok) {
      btns.forEach((b) => { b.disabled = false; });
      if (res.data.error === 'discount') {
        // The code stopped being valid between Apply and Confirm (usually a
        // first-order code on a returning number). Drop it and re-quote so the
        // customer sees the real total before committing.
        appliedDiscount = null;
        const msg = document.getElementById('co-disc-msg');
        if (msg) { msg.classList.remove('ok'); msg.classList.add('bad'); msg.textContent = res.data.message; }
        renderCheckoutSummary();
        toast('تم تحديث الإجمالي — راجعي الطلب');
        return;
      }
      const errField = { name: 'co-name', phone: 'co-phone', city: 'co-city', address: 'co-address' }[res.data.error];
      if (errField) fieldErr(errField, res.data.message);
      else toast(res.data.message || 'حدث خطأ — حاولي مرة أخرى');
      return;
    }

    track('purchase', { orderNumber: res.data.orderNumber, total: res.data.total });
    setCart([]);
    const body = sheets.checkout.body;
    body.textContent = '';
    body.appendChild(el('div', { class: 'co-success' }, [
      el('div', { class: 'co-success-icon', text: '✓' }),
      el('h3', { text: 'تم استلام طلبك بنجاح!' }),
      el('div', {}, [el('span', { class: 'co-ordernum', text: res.data.orderNumber })]),
      el('p', { text: `الإجمالي: ${fmtSar(res.data.total)} — الدفع عند الاستلام. بنتواصل معك قريباً لتأكيد الطلب، واحتفظي برقم الطلب للمتابعة.` }),
    ]));
    body.appendChild(el('button', { class: 'shop-cta', text: 'متابعة التسوق', onclick: () => closeSheet('checkout') }));
  }

  /* ── Newsletter ── */
  function wireNewsletter() {
    const rows = document.querySelectorAll('.newsletter .nl-row');
    rows.forEach((row) => {
      const input = row.querySelector('input');
      const btn = row.querySelector('.nl-submit');
      if (!input || !btn) return;
      const type = input.type === 'tel' ? 'sms' : 'email';
      btn.addEventListener('click', async () => {
        const value = input.value.trim();
        row.querySelectorAll('.nl-err-inline').forEach((n) => n.remove());
        if (!value) { input.focus(); return; }
        btn.disabled = true;
        let ok;
        const data = { discountCode: 'WELCOME15', percent: 15 };
        try {
          if (type === 'email') {
            if (!looksLikeEmail(value)) { btn.disabled = false; toast('البريد الإلكتروني غير صحيح'); input.focus(); return; }
            ok = await storefrontFormPost({ form_type: 'customer', 'contact[email]': value, 'contact[tags]': 'newsletter' });
          } else {
            const phone = foldDigits(value);
            if (!/^(?:00966|\+?966|0)?\s*5[\d\s-]{8,}$/.test(phone)) { btn.disabled = false; toast('رقم الجوال غير صحيح — مثال: 05XXXXXXXX'); input.focus(); return; }
            ok = await storefrontFormPost({ form_type: 'contact', 'contact[email]': 'sms-signup@sedrah.site', 'contact[name]': 'SMS signup', 'contact[body]': 'تسجيل SMS من الموقع: ' + phone });
          }
        } catch {
          btn.disabled = false;
          toast('تعذر الاتصال بالخادم — حاولي مرة أخرى');
          return;
        }
        btn.disabled = false;
        if (!ok) {
          toast('تحقق من البيانات المدخلة');
          input.focus();
          return;
        }
        track('sign_up', { type });
        const success = el('div', { class: 'nl-success' });
        success.appendChild(el('span', { text: 'تم التسجيل بنجاح 🎉 استخدمي كود ' }));
        success.appendChild(el('strong', { text: data.discountCode, dir: 'ltr' }));
        success.appendChild(el('span', { text: ` لخصم ${arNum(data.percent)}٪ على طلبك الأول.` }));
        success.setAttribute('dir', 'rtl');
        row.replaceWith(success);
      });
    });
  }

  /* ── Contact sheet (chat FAB) ── */
  function openContact() {
    const s = sheets.contact || buildSheet('contact', 'تواصلي معنا');
    const body = s.body;
    body.textContent = '';
    body.appendChild(el('p', { class: 'contact-intro', text: 'عندك سؤال عن منتجاتنا أو طلبك؟ اكتبي لنا وبنرد عليك بأقرب وقت.' }));
    body.appendChild(field('ct-name', 'الاسم'));
    body.appendChild(field('ct-contact', 'رقم الجوال أو البريد الإلكتروني', { dir: 'ltr' }));
    body.appendChild(field('ct-text', 'رسالتك', { textarea: true }));
    body.appendChild(el('button', {
      class: 'shop-cta', text: 'إرسال',
      onclick: async function () {
        const name = fieldVal('ct-name'), contact = fieldVal('ct-contact'), text = fieldVal('ct-text');
        if (!name || !contact || !text) { toast('الرجاء تعبئة جميع الحقول'); return; }
        this.disabled = true;
        let ok;
        const data = { message: 'وصلتنا رسالتك، بنرد عليك بأقرب وقت 🌿' };
        try {
          ok = await storefrontFormPost({
            form_type: 'contact',
            'contact[email]': looksLikeEmail(contact) ? contact : 'phone-contact@sedrah.site',
            'contact[name]': name,
            'contact[body]': text + (looksLikeEmail(contact) ? '' : '\n\nرقم التواصل: ' + contact),
          });
        } catch {
          this.disabled = false;
          toast('تعذر الاتصال بالخادم — حاولي مرة أخرى');
          return;
        }
        this.disabled = false;
        if (!ok) { toast('حدث خطأ'); return; }
        closeSheet('contact');
        toast(data.message);
      },
    }));
    openSheet('contact');
  }

  /* ── Review form (reviews page) ── */
  function wireReviewForm() {
    const host = document.getElementById('reviewFormHost');
    if (!host) return;
    let rating = 5;
    let product = '';
    const starsRow = el('div', { class: 'rv-stars-input', role: 'radiogroup', 'aria-label': 'التقييم' });
    const starBtns = [];
    for (let i = 1; i <= 5; i++) {
      const b = el('button', { class: 'rv-star on', type: 'button', 'aria-label': i + ' نجوم', text: '★', onclick: () => { rating = i; starBtns.forEach((sb, j) => sb.classList.toggle('on', j < i)); } });
      starBtns.push(b);
      starsRow.appendChild(b);
    }
    const pills = el('div', { class: 'rv-product-row' });
    [['', 'تجربة عامة'], ['restore-mask', 'الماسك'], ['essence-oil', 'الزيت']].forEach(([slug, label], idx) => {
      const p = el('button', { class: 'rv-product-pill' + (idx === 0 ? ' on' : ''), type: 'button', text: label, onclick: function () { product = slug; pills.querySelectorAll('.rv-product-pill').forEach((x) => x.classList.remove('on')); this.classList.add('on'); } });
      pills.appendChild(p);
    });
    host.appendChild(el('div', { class: 'rv-form-card' }, [
      el('div', { class: 'rv-form-title', text: 'شاركينا تجربتك ✍️' }),
      starsRow,
      pills,
      field('rv-name', 'الاسم'),
      field('rv-text', 'تقييمك', { textarea: true }),
      el('button', {
        class: 'shop-cta', text: 'إرسال التقييم',
        onclick: async function () {
          const author = fieldVal('rv-name'), text = fieldVal('rv-text');
          if (!author || !text) { toast('الرجاء كتابة الاسم والتقييم'); return; }
          this.disabled = true;
          let ok;
          const data = { message: 'شكراً لك! سيظهر تقييمك بعد المراجعة.' };
          try {
            ok = await storefrontFormPost({
              form_type: 'contact',
              'contact[email]': 'review-form@sedrah.site',
              'contact[name]': author,
              'contact[body]': 'تقييم جديد من الموقع\nالتقييم: ' + rating + '/5\nالمنتج: ' + (product || 'تجربة عامة') + '\n\n' + text,
            });
          } catch {
            this.disabled = false;
            toast('تعذر الاتصال بالخادم — حاولي مرة أخرى');
            return;
          }
          this.disabled = false;
          if (!ok) { toast('حدث خطأ'); return; }
          const card = this.closest('.rv-form-card');
          card.textContent = '';
          card.appendChild(el('div', { class: 'rv-sent', text: data.message }));
        },
      }),
    ]));
  }

  /* ── Wiring onto existing page elements ── */
  function sizeToCode(productSlug, sizeLabel) {
    const p = catalog.products.find((x) => x.slug === productSlug);
    if (!p) return null;
    const v = p.variants.find((x) => x.size === sizeLabel);
    return v ? v.code : null;
  }

  async function addFromModal(modalId, productSlug) {
    try { await loadCatalog(); } catch { toast('تعذر تحميل المنتجات'); return; }
    const modal = document.getElementById(modalId);
    const sizeBtn = modal.querySelector('.pdp-size.active');
    const modeEl = modal.querySelector('.pdp-radio.active');
    const qtyEl = modal.querySelector('.pdp-qty span');
    let code = sizeToCode(productSlug, sizeBtn ? sizeBtn.textContent.trim() : '');
    if (!code && !sizeBtn) {
      // Single-variant modals (the bundle) have no size pills — fall back to the first variant.
      const p = catalog.products.find((x) => x.slug === productSlug);
      if (p && p.variants.length) code = p.variants[0].code;
    }
    if (!code) { toast('المقاس غير متوفر'); return; }
    const qty = Math.max(1, parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1);
    const mode = modeEl && modeEl.dataset.mode === 'sub' ? 'sub' : 'once';
    addToCart(code, qty, mode);
  }

  function wirePage() {
    // Header cart icon
    const cartBtn = document.querySelector('header .hdr-icons button[aria-label="Cart"]');
    if (cartBtn) cartBtn.addEventListener('click', openCart);

    // Product-card quick add
    document.querySelectorAll('.prod-add').forEach((btn) => {
      const label = btn.getAttribute('aria-label') || '';
      const slug = label.includes('Restore Mask') ? 'restore-mask' : label.includes('Essence Oil') ? 'essence-oil' : label.includes('Sedar Ritual') ? 'sedar-ritual' : null;
      if (!slug) return;
      btn.addEventListener('click', async () => {
        try { await loadCatalog(); } catch { toast('تعذر تحميل المنتجات'); return; }
        const p = catalog.products.find((x) => x.slug === slug);
        if (!p || !p.variants.length) { toast('المنتج غير متوفر حالياً'); return; }
        addToCart(p.variants[0].code, 1, 'once');
      });
    });

    // PDP add-to-cart
    document.querySelectorAll('#productModal .pdp-atc').forEach((b) => b.addEventListener('click', () => addFromModal('productModal', 'restore-mask')));
    document.querySelectorAll('#oilModal .pdp-atc').forEach((b) => b.addEventListener('click', () => addFromModal('oilModal', 'essence-oil')));
    document.querySelectorAll('#bundleModal .pdp-atc').forEach((b) => b.addEventListener('click', () => addFromModal('bundleModal', 'sedar-ritual')));

    // view_item tracking on modal open
    [['openProductModal', 'restore-mask'], ['openOilModal', 'essence-oil'], ['openBundleModal', 'sedar-ritual']].forEach(([fn, slug]) => {
      const orig = window[fn];
      if (typeof orig === 'function') {
        window[fn] = function () { track('view_item', { product: slug }); return orig.apply(this, arguments); };
      }
    });

    // Chat FAB → contact sheet
    const fab = document.querySelector('.chat-fab');
    if (fab) fab.addEventListener('click', openContact);

    wireNewsletter();
    wireReviewForm();
    updateBadge();
    loadCatalog().then(reflectAvailability).catch(() => { /* retried on first interaction */ });
    reconcileAfterCheckout();
  }

  // Cards and modals never knew about stock. Disable the buy buttons for anything sold out.
  const MODAL_BY_SLUG = { 'restore-mask': 'productModal', 'essence-oil': 'oilModal', 'sedar-ritual': 'bundleModal' };
  const CARD_LABEL_BY_SLUG = { 'restore-mask': 'Restore Mask', 'essence-oil': 'Essence Oil', 'sedar-ritual': 'Sedar Ritual' };
  function reflectAvailability() {
    if (!catalog) return;
    catalog.products.forEach((p) => {
      const soldOut = !p.variants.some((v) => v.available !== false);
      if (!soldOut) return;
      document.querySelectorAll('.prod-add').forEach((b) => {
        if ((b.getAttribute('aria-label') || '').includes(CARD_LABEL_BY_SLUG[p.slug])) { b.disabled = true; b.setAttribute('aria-label', 'Sold out'); b.classList.add('is-soldout'); }
      });
      const modal = document.getElementById(MODAL_BY_SLUG[p.slug]);
      if (modal) modal.querySelectorAll('.pdp-atc').forEach((b) => { b.disabled = true; b.textContent = 'نفدت الكمية — Sold Out'; b.classList.add('is-soldout'); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wirePage);
  else wirePage();

  // Small public surface (debug/manual use)
  window.Shop = { add: addToCart, openCart, openContact, track };
})();
